
/**
 *  13/05/2019 v 1.0 - JuanMa
 *  v1   25/07/19  en getFiltroFromCampo, añadida la propiedad tipoCampo, para filtrar los Check posteriormente
 *  v2.0 26/10/20  en getFiltroFromCampo, añadida la propiedad valor2, para usarlta en los ENTRE y ENTREFECHAS
 *  v2.1 09/11/20  en getFiltroFromCampo, añadimos al objeto resultante noFiltrar tal como viene del campo origen, para poder usarlo en FormularioGrid
 *  v2.2 04/01/20  en getFiltroFromCampo, en el caso de tipo default, si el subtipo es BUSQUEDACAMPOTIPO_CADENA, usamos FILTRO_CONTAINING
 *  v2.3 06/06/21  creada la funcion getFiltroFromCampo35 y getFiltroInicialFromCampoFECHAPERIODO35
 *
 *  v2.4 06/05/22  Unión Planifikator y Sidemur
 *  v2.5 24/05/22  Añadida funcion getFiltroFromCondicion
 *  v2.6 29/04/23  Modificada función getFiltroFromCampo para que en el caso BUSQUEDACAMPOTIPO_CADENA use FILTRO_LIKE
 *  v2.7 13/09/23  Modificada la función getFiltroFromCampo para que los Checks devuelvan true/false en vez de 1/0
 * */

import {
    BUSQUEDACAMPOTIPO_CADENA,
    BUSQUEDACAMPOTIPO_CHECK, BUSQUEDACAMPOTIPO_FECHAPERIODO,
    FILTRO_CONTAINING, FILTRO_ENTREFECHAS,
    FILTRO_IGUAL, FILTRO_LIKE,
    FILTRO35_CONTAINING, FILTRO35_ENTREFECHAS,
    FILTRO35_IGUAL
} from "../UI/FormularioGridBusqueda";
import {getPeriodoDeTipo} from "../UI/SelectorPeriodo";


export const getFiltroFromCondicion= (condicion) => {
    let tipo= condicion.tipo;
    let campo= condicion.campo;
    let valor= condicion.valor;

    return {tipo: condicion.tipo, nombreCampo: condicion.campo, valor: condicion.valor, valor2: condicion.valor2};
}

export const getFiltroFromCampo= (campo, valorActual, valorActual2) => {
    //let tipoFiltro= FILTRO_CONTAINING;


    //console.log("********* getFiltroFromCampo");
    //console.log("campo.tipo: ", campo.tipo);
    //console.log("valorActual: ", valorActual);


    let tipoFiltro= FILTRO_IGUAL;
    switch (campo.tipo){
        case BUSQUEDACAMPOTIPO_CADENA:
            //tipoFiltro= FILTRO_CONTAINING;
            tipoFiltro= FILTRO_LIKE;
            break;
        case BUSQUEDACAMPOTIPO_CHECK:
            tipoFiltro= FILTRO_IGUAL;
            /* Comentado el 13/09/2023
            if (valorActual === true)
                valorActual= 1;
            else
                valorActual= 0;
             */
            break;
        case BUSQUEDACAMPOTIPO_FECHAPERIODO:
            //console.log("!!! BUSQUEDACAMPOTIPO_FECHAPERIODO");
            tipoFiltro= FILTRO_ENTREFECHAS;
            if (valorActual) {
                let valorOrig = {...valorActual};
                valorActual = valorOrig.desde;
                valorActual2 = valorOrig.hasta;
            }
            break;
        default:
            if (campo.subtipo === BUSQUEDACAMPOTIPO_CADENA)
                tipoFiltro= FILTRO_CONTAINING;
            break;
    }
    //console.log("tipoFiltro: ", tipoFiltro);

    let noFiltrar=  campo.noFiltrar != undefined  && Boolean(campo.noFiltrar);

    //console.log("valor final: ", valorActual);

    //- Anterior #
    //|
    //V
    //return {tipo: tipoFiltro, nombreCampo: campo.campo, valor: valorActual, valor2: valorActual2, tipoCampo: campo.tipo};


    return {tipo: tipoFiltro, nombreCampo: campo.campo, valor: valorActual, valor2: valorActual2, noFiltrar: noFiltrar}; //Antes de 11/09/23


}


export const getFiltroFromCampo35= (campo, valorActual, valorActual2) => {
    //let tipoFiltro= FILTRO_CONTAINING;

    /*
    console.log("** getFiltroFromCampo");
    console.log("campo.tipo: ", campo.tipo);
    console.log("valorActual: ", valorActual)
    */

    let tipoFiltro= FILTRO35_IGUAL;
    switch (campo.tipo){
        case BUSQUEDACAMPOTIPO_CADENA:
            tipoFiltro= FILTRO35_CONTAINING;
            break;
        case BUSQUEDACAMPOTIPO_CHECK:
            tipoFiltro= FILTRO35_IGUAL;
            if (valorActual === true)
                valorActual= 1;
            else
                valorActual= 0;
            break;
        case BUSQUEDACAMPOTIPO_FECHAPERIODO:
            console.log("!!! BUSQUEDACAMPOTIPO_FECHAPERIODO");
            tipoFiltro= FILTRO35_ENTREFECHAS;
            if (valorActual) {
                let valorOrig = {...valorActual};
                valorActual = valorOrig.desde;
                valorActual2 = valorOrig.hasta;
            }
            break;
        default:
            if (campo.subtipo === BUSQUEDACAMPOTIPO_CADENA)
                tipoFiltro= FILTRO35_CONTAINING;
            break;
    }

    let noFiltrar=  campo.noFiltrar != undefined  && Boolean(campo.noFiltrar);

    console.log("valor final: ", valorActual);

    //- Anterior #
    //|
    //V
    //return {tipo: tipoFiltro, nombreCampo: campo.campo, valor: valorActual, valor2: valorActual2, tipoCampo: campo.tipo};
    return {tipo: tipoFiltro, nombreCampo: campo.campo, valor: valorActual, valor2: valorActual2, noFiltrar: noFiltrar};

}

export const getFiltroInicialFromCampoFECHAPERIODO= (campo) => {
    if (campo.tipo === BUSQUEDACAMPOTIPO_FECHAPERIODO && campo.tipoValor){
        let tipoFiltro= FILTRO_ENTREFECHAS;
        let periodo= getPeriodoDeTipo(campo.tipoValor);
        let valor = periodo.desde;
        let valor2 = periodo.hasta;
        return {tipo: tipoFiltro, nombreCampo: campo.campo, valor: valor, valor2: valor2};
    }
}


export const getFiltroInicialFromCampoFECHAPERIODO35= (campo) => {
    if (campo.tipo === BUSQUEDACAMPOTIPO_FECHAPERIODO && campo.tipoValor){
        let tipoFiltro= FILTRO35_ENTREFECHAS;
        let periodo= getPeriodoDeTipo(campo.tipoValor);
        let valor = periodo.desde;
        let valor2 = periodo.hasta;
        return {tipo: tipoFiltro, nombreCampo: campo.campo, valor: valor, valor2: valor2};
    }
}